module.exports = __webpack_public_path__ + "img/home.3cda1848.png";